import React, { useState, useEffect, Suspense } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { Caption, Small } from 'deltoid/core/Blocks/Typography';
import PayuIcons from 'deltoid/core/PayUIcons';
import Form from 'deltoid/core/Form';
import Timer from '@components/BaseComponents/Timer';

import { serviceAgreementSelectors, serviceAgreementActions, toastActions, merchantSelectors, dialogActions } from '@store/ducks';
const PDFViewer = React.lazy(() => import('@components/BaseComponents/PDFViewer'));

const Esign = ({
  getDetails,
  signingAuthorityDetails,
  sendOtp,
  verifyOtp,
  showToast,
  close,
  verifyProcessing,
  verifyOtpErr,
}) => {
  const [tnc, setTnc] = useState(true);
  const [otpValue, setOtpValue] = useState(null);
  const [retryTime, setRetryTime] = useState(false);
  const [err, setErr] = useState(false);
  const { kyc_document } = getDetails || { kyc_document: {} };
  const documentPath = kyc_document?.processed_document?.path;
  const { email } = signingAuthorityDetails[0] || {};
  const kycDocumentUuid = kyc_document?.uuid;

  useEffect(() => {
    if (verifyOtpErr) setErr(verifyOtpErr);
  }, [verifyOtpErr])

  const onSubmit = () => {
    if (otpValue && otpValue.length==4) {
      if (tnc) {
        verifyOtp(otpValue, kycDocumentUuid);
      } else {
        showToast({
          variant: 'info',
          title: 'Info',
          content: 'Please accept Terms and conditions',
        });
      }
    } else {
      setErr('Enter complete otp');
    }
  }

  return (
    <Row noGutters>
      <Col md={12}>
        <div className='d-flex justify-content-between p-3 align-items-baseline shadow-sm'>
          <Caption>Service agreement</Caption>
          <div className='d-flex'>
            {
              documentPath && (
                <Form.Button
                  className='mr-2'
                  onClick={() => window.open(documentPath, '_blank')}
                  variant='outlined'
                  startIcon={{ type: 'download', color: 'primaary'}}
                >
                  Download
                </Form.Button>
              )
            }
            <span onClick={close} className='align-self-center cursor-pointer'>
              <PayuIcons type='cancel' size="16px"/>
            </span>
          </div>
        </div>
      </Col>
      <Col md={8} className='p-3'>
        {
          documentPath ? (
            <Suspense fallback={<p>...</p>}>
              <PDFViewer
                filePath={documentPath}
                onLoad={pdf => console.log(pdf)}
              />
            </Suspense>
          ) : 'NA'
        }
      </Col>
      <Col md={4} className='p-3'>
        {
          documentPath && (
          <>
            <Caption>Enter 4-digit OTP</Caption>
            <Small className='pb-2'>OTP is sent to {email ? email : 'NA'}</Small>
            <Form.Group>
              <Form.OTP
                length={4}
                shouldAutoFocus
                onChange={(v) => {
                  setOtpValue(v);
                  setErr(false);
                }}
                className='test-otp-class'
                label={'label'}
              />
              {err && <Form.Message type='error'>{err}</Form.Message>}
            </Form.Group>
            <Form.Button className='w-100' onClick={onSubmit} disabled={verifyProcessing} loading={verifyProcessing}>
              Submit OTP
            </Form.Button>
            <div className='d-flex flex-row align-items-baseline mt-2'>
              <Form.Checkbox
                id='tnc-and-privacy'
                name='tnc-and-privacy'
                onChange={(e) => setTnc(e.target.checked)}
                checked={tnc}
              />
              <Form.Label className='align-self-end pl-2' id='tnc-and-privacy'>
                I agree the Terms & Conditions and Privacy Policy
              </Form.Label>
            </div>
            <div className='d-flex justify-content-between align-items-baseline'>
              <Caption>Haven’t received OTP?</Caption>
              <Form.Button variant='underlined' disabled={!!retryTime} onClick={() => {
                if (kycDocumentUuid) sendOtp(kycDocumentUuid);
                setRetryTime(60*1000);
              }}>
                Resend OTP{' '}
                {
                  retryTime && <Timer
                    interval={retryTime}
                    className='d-inline'
                    onComplete={() => setRetryTime(false)}
                  />
                }
              </Form.Button>
            </div>
          </>
        )}
      </Col>
    </Row>
  )
};

const mapStateToProps = (state) => ({
  getDetails: serviceAgreementSelectors.getDetails(state),
  verifyOtpErr: serviceAgreementSelectors.verifyOtpErr(state),
  verifyProcessing: serviceAgreementSelectors.verifyProcessing(state),
  getIsServiceAgreementEsigned: merchantSelectors.getIsServiceAgreementEsigned(state),
  signingAuthorityDetails: merchantSelectors.getSigningAuthorityDetails(state),
});

const mapDispatchToProps = (dispatch) => ({
  sendOtp: (kycDocumentUuid) =>
    dispatch(serviceAgreementActions.sendOtp(kycDocumentUuid)),
  verifyOtp: (otp, kycDocumentUuid) =>
    dispatch(serviceAgreementActions.verifyOtp(otp, kycDocumentUuid)),
  showToast: (toastProps) => dispatch(toastActions.show(toastProps)),
  close: () => dispatch(dialogActions.close()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Esign);
